import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/build/repo/packages/christiecookies/frontend/app/[locale]/layout-provider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/christiecookies/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/christiecookies/frontend/styles/app.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/christiecookies/frontend/styles/custom.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/christiecookies/frontend/node_modules/@rich-products-corp/react-ecomm-ui/dist/styles/aries-ui.css");
